export default __webpack_public_path__ + "static/media/eye.c9af98e1.svg";